import React from 'react';
import { CommonLabel as Label } from '@/components/ui/common-label';
import { 
  User, 
  Camera,
  Building
} from 'lucide-react';

const ProfileCard = ({ profileData }) => {

  const getUserInitials = (name) => {
    if (!name) return 'AD';
    const names = name.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };

  const initials = getUserInitials(profileData.name);

  return (
    <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform" style={{boxShadow: '0px 2px 10px 0px hsl(var(--border) / 0.1)'}}>
      <div className="border border-border px-4 py-4 rounded-[16px] bg-background">
        <Label size="lg" weight="bold" className="text-foreground mb-4 block">Profile Picture</Label>
        <div className="flex flex-col items-center">
          <div className="relative">
            <div className="w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="text-3xl font-bold text-primary">{initials}</span>
            </div>
           
          </div>
          <Label size="xl" weight="bold" className="mt-4">{profileData.name}</Label>
          <Label size="sm" className="text-muted-foreground">{profileData.role}</Label>
          {profileData.companyName && (
            <div className="mt-2 flex items-center text-muted-foreground">
              <Building className="h-4 w-4 mr-1" />
              <Label size="sm">{profileData.companyName}</Label>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;